import { ArrowRight, Clock3 } from 'lucide-react';
import type { Service } from '@/types/domain/service';

const currency = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });

export function CompanyQueueServices({
  services,
  onSelect,
  isLoading,
  isError,
  onRetry,
}: {
  services: Service[];
  onSelect: (serviceId: string) => void;
  isLoading: boolean;
  isError: boolean;
  onRetry: () => void;
}) {
  return (
    <section className="space-y-3">
      <div>
        <h2 className="text-xl font-bold">Serviços</h2>
        <p className="text-muted-foreground mt-1 text-sm">
          Conheça os serviços. Primeiro você garante seu lugar; depois decide o que fazer.
        </p>
      </div>
      {isLoading && (
        <p role="status" className="text-muted-foreground py-6 text-sm">
          Carregando serviços…
        </p>
      )}
      {isError && (
        <div role="alert" className="rounded-xl border p-4 text-sm">
          Não foi possível carregar os serviços.{' '}
          <button onClick={onRetry} className="text-primary underline">
            Tentar novamente
          </button>
        </div>
      )}
      {!isLoading && !isError && services.length === 0 && (
        <p className="text-muted-foreground py-6 text-sm">Nenhum serviço disponível no momento.</p>
      )}
      {services.map((service) => (
        <button
          key={service.id}
          type="button"
          onClick={() => onSelect(service.id)}
          className="border-border bg-card hover:border-primary/40 focus-visible:ring-primary flex w-full items-center gap-4 rounded-xl border p-4 text-left transition-colors focus-visible:ring-2"
        >
          <span className="min-w-0 flex-1">
            <span className="block font-semibold">{service.name}</span>
            <span className="text-muted-foreground mt-1 flex items-center gap-1 text-xs">
              <Clock3 className="h-3 w-3" aria-hidden="true" />
              {service.durationMin} min de atendimento
            </span>
          </span>
          <span className="shrink-0 text-sm font-semibold">{currency.format(service.price)}</span>
          <ArrowRight className="text-primary h-4 w-4 shrink-0" aria-hidden="true" />
        </button>
      ))}
    </section>
  );
}
